"use client";

import Link from "next/link";
import React, { useEffect, useState } from "react";
import { getSession, type PortalSession } from "@/app/lib/weddingPortal";

function getDashboardHref(session: PortalSession | null) {
  if (!session) return "/";
  return session.role === "superadmin" ? "/super" : "/dashboard";
}

export default function SessionBackLink() {
  const [session, setSession] = useState<PortalSession | null>(() => {
    if (typeof window === "undefined") {
      return null;
    }

    return getSession();
  });

  useEffect(() => {
    function handleStorage() {
      setSession(getSession());
    }

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  return (
    <Link
      href={getDashboardHref(session)}
      className="rounded-full border border-[#caa23a]/60 bg-white px-5 py-2 text-sm font-semibold text-[#1f4e79] transition hover:bg-[#f2ecdf]"
    >
      Back
    </Link>
  );
}
